import { ThemeProvider, alpha, createTheme, useTheme } from "@mui/material";
import { useEffect, useMemo, ReactNode } from "react";
import { useEnvConfig } from "../../api/config";

export const EnvConfigProvider = ({ children }: { children: ReactNode }) => {
  const { data: config } = useEnvConfig();
  const baseTheme = useTheme();

  useEffect(() => {
    if (config?.appName) {
      document.title = config.appName;
    }
    if (config?.logoFavicon) {
      const link =
        (document.querySelector("link[rel='icon']") as HTMLLinkElement) ??
        Object.assign(document.createElement("link"), { rel: "icon" });
      link.href = config.logoFavicon;
      document.head.appendChild(link);
    }
  }, [config?.appName, config?.logoFavicon]);

  const brandedTheme = useMemo(() => {
    if (!config?.colorBackgroundDark) return null;
    const primary = config.colorBackgroundDark;
    return createTheme(baseTheme, {
      palette: {
        primary: { main: primary },
        action: {
          hover: alpha(primary, 0.08),
          selected: alpha(primary, 0.12),
          focus: alpha(primary, 0.12),
        },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            containedPrimary: {
              "&:hover": { backgroundColor: alpha(primary, 0.85) },
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            colorPrimary: {
              "&:hover": { backgroundColor: alpha(primary, 0.08) },
            },
          },
        },
      },
    });
  }, [baseTheme, config?.colorBackgroundDark]);

  if (brandedTheme) {
    return <ThemeProvider theme={brandedTheme}>{children}</ThemeProvider>;
  }
  return <>{children}</>;
};
